module.exports = __webpack_public_path__ + "img/floppy-disk-circle-arrow-right.3bd67483.svg";